import { combineReducers } from 'redux';
import user from './user';
import runtime from './runtime';
import intl from './intl';
import siteSettings from './siteSettings';
import loader from './loader';
import commonSettings from './commonSettings';
import modalStatus from './modalReducer';
import operationHours from './operationHours';
import menu from './menu';
// External Reducers
import { reducer as formReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';

import currency from './currency';
import payout from './payout';
import account from './account';
import payoutChangeListing from './payoutChangeListing';
import common from './common';
import adminModalStatus from './adminModalStatus';
import orderData from './orderData';
import adminBanners from './adminBanners';
import adminShopCategoryIcons from './adminShopCategoryIcons';

export default combineReducers({
  user,
  runtime,
  intl,
  form: formReducer,
  toastr: toastrReducer,
  currency,
  siteSettings,
  loader,
  commonSettings,
  modalStatus,
  payout,
  account,
  operationHours,
  payoutChangeListing,
  common,
  adminModalStatus,
  orderData,
  adminBanners,
  adminShopCategoryIcons,
  menu
});
